import React from "react"
import styled from "styled-components"

export const StyledVerificationPopUp = styled.div`
  background: #00b055;
  box-shadow: 0 4px 8px 0 rgba(151, 151, 151, 0.5);
  border-radius: 4px;
  width: 100%;
  max-width: 460px;
  position: fixed;
  left: 50%;
  transform: translateX(-50%);
  top: 22px;
  padding: 18px;
  z-index: 2000;
  transition: all 300ms ease-in;

  .close-button {
    position: absolute;
    right: 18px;
    background: transparent;
    outline: none;
    border: none;
    top: 8px;
    cursor: pointer;

    .close-icon {
      color: #ffffff;
    }
  }

  .text {
    font-size: 16px;
    color: #ffffff;
    letter-spacing: 0.3px;
    text-align: center;
    line-height: 26px;
    margin-bottom: 0;
  }

  .highlighted {
    font-size: 16px;
    color: #ffffff;
  }

  .redirect-button {
    background: transparent;
    outline: none;
    border: none;
    padding: 0;
    color: #ffffff;
    text-decoration: underline;
    cursor: pointer;
  }
`

const PopUp = ({ onClose, onRedirect }) => {
  return (
    <StyledVerificationPopUp>
      <button onClick={onClose} className="close-button">
        <p className="close-icon">X</p>
      </button>
      <p className="text">
        Your account is now <strong className="highlighted">verified.</strong>
      </p>
      <p className="text">
        Complete your profile{" "}
        <button onClick={onRedirect} className="redirect-button">
          here.
        </button>
      </p>
    </StyledVerificationPopUp>
  )
}

export default PopUp
